import React, { Component } from 'react'
import NavigationAppShell from '../../common/navigation-app-shell'
import SubscriptionSummary from './containers/subscription-summary'
import DataGraph from './containers/data-graph'
import DataHistory from './containers/data-history'
import EditSubscriptionDialog from './containers/edit-subscription-dialog'

class SubscriptionDetailsPage extends Component {
  render () {
    return (
      <NavigationAppShell
        content={
          <div>
            <SubscriptionSummary id={this.props.match.params.id} />
            <DataGraph id={this.props.match.params.id} />
            <DataHistory id={this.props.match.params.id} />
            <EditSubscriptionDialog />
          </div>
        }
        pageName={'Subscription details'}
      />
    )
  }
}

export default SubscriptionDetailsPage



// WEBPACK FOOTER //
// ./src/pages/subscription-details/index.js